/**
 * dt-wishlist.js
 *
 * Manages the wishlist in localStorage and updates the <dtx-wishlist> in the header
 * so the bubble appears with the correct count immediately.
 */
class dT_WhistList {
  constructor() {
    this.KEY = 'shopify-wishlist';
    this.DELIM = ',';
  }

  getWishlist() {
    const raw = localStorage.getItem(this.KEY) || '';
    return raw ? raw.split(this.DELIM) : [];
  }

  setWishlist(handles) {
    if (handles.length) {
      localStorage.setItem(this.KEY, handles.join(this.DELIM));
    } else {
      localStorage.removeItem(this.KEY);
    }
  }

  getTotalCount() {
    return this.getWishlist().length;
  }

  isInList(handle) {
    return this.getWishlist().includes(handle);
  }

  add(handle) {
    const arr = this.getWishlist();
    if (!arr.includes(handle)) arr.push(handle);
    this.setWishlist(arr);
  }

  remove(handle) {
    const arr = this.getWishlist().filter(h => h !== handle);
    this.setWishlist(arr);
  }

  toggle(handle) {
    if (this.isInList(handle)) {
      this.remove(handle);
    } else {
      this.add(handle);
    }
  }
}

/**
 * <dtx-wishlist> custom element
 * - If it has a .add-wishlist button, handles "add/remove" clicks for a product
 * - Always has a .updateCounter() method to show the correct bubble count in the header
 */
class dTXWishlist extends HTMLElement {
  constructor() {
    super();
    this._wishList = new dT_WhistList();

    // If this element has a button .add-wishlist, set it up
    this.addButton = this.querySelector('.add-wishlist');
    if (this.addButton) {
      this.handle = this.addButton.dataset.product_handle;
      this.addButton.addEventListener('click', e => this.onClick(e));
      // If already in wishlist, mark the button
      if (this._wishList.isInList(this.handle)) {
        this.addButton.classList.add('added');
      }
    }

    // First load, show correct bubble in case this is in the header
    this.updateCounter();
  }

  onClick(e) {
    e.preventDefault();
    if (!this.handle) return;

    // Toggle in localStorage
    this._wishList.toggle(this.handle);

    // If we just added it, mark the button, otherwise unmark
    if (this._wishList.isInList(this.handle)) {
      this.addButton.classList.add('added');
    } else {
      this.addButton.classList.remove('added');
    }

    // Immediately refresh the bubble in the header
    this.updateAllHeaderBubbles();
  }

  /**
   * Called automatically once on load. Also call this manually
   * to refresh the bubble if items are added/removed.
   */
  updateCounter() {
    // Get count
    const total = this._wishList.getTotalCount();

    // If there's a .grid-count-bubble inside, show/hide it
    const bubble = this.querySelector('.grid-count-bubble');
    if (bubble) {
      const span = bubble.querySelector('span');
      if (total > 0) {
        bubble.style.display = 'flex';
        span.textContent = total;
      } else {
        bubble.style.display = 'none';
        span.textContent = '';
      }
    }
  }

  /**
   * This method refreshes ALL <dtx-wishlist> elements in the header, so
   * the bubble count is always up to date on every instance (e.g. mobile vs. desktop).
   */
  updateAllHeaderBubbles() {
    const els = document.querySelectorAll('dtx-wishlist');
    els.forEach(el => el.updateCounter());
  }
}

customElements.define('dtx-wishlist', dTXWishlist);
